/**
 * FlowCoachPane - Flow Coach tab for DetailSidebar
 * Wraps FlowCoachPanel with hook-based data fetching
 */

import { useCallback } from 'react'
import { useSessionStore } from '@/stores/sessionStore'
import { useJourneyStore } from '@/stores/journeyStore'
import { useFlowWorkflow } from '@/hooks/useFlowWorkflow'
import { useEntityCreation } from '@/hooks/useEntityTree'
import { FlowCoachPanel } from '@/components/flow/FlowCoachPanel'

export function FlowCoachPane() {
  const { accountId, projectId } = useSessionStore()
  const { fetchJourney } = useJourneyStore()

  const { currentPhase, phaseEntityCards } = useFlowWorkflow()
  const { createEntityAsync } = useEntityCreation()

  // Handle entity creation from Flow Coach chat
  const handleCreateEntity = useCallback(
    async (type: string, label: string, description: string) => {
      await createEntityAsync({
        entityType: type,
        label,
        description,
      })

      // Refresh journey to update counts
      if (accountId && projectId) {
        await fetchJourney(accountId, projectId)
      }
    },
    [createEntityAsync, accountId, projectId, fetchJourney]
  )

  return (
    <FlowCoachPanel
      phase={currentPhase}
      entityCards={phaseEntityCards}
      onCreateEntity={handleCreateEntity}
      className="h-full"
    />
  )
}
